import { COLOR, FONT_SIZE, FONT_WEIGHT, mq, Skeleton as _Skeleton } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { HIDE_SCROLL_BAR } from "~/styles/hide-scroll-bar";

export const DivContainer = styled.div<{ isVideoSubPage: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  overflow-x: auto;
  ${({ isVideoSubPage }) => !isVideoSubPage && `margin-top: 32px;`}
  height: 40px;

  ${mq.sp} {
    height: 72px;
  }
`;

export const DivWrapper = styled.div`
  display: flex;
  align-items: center;
  overflow-x: auto;
  padding: 0 32px;

  ${HIDE_SCROLL_BAR}

  ${mq.sp} {
    padding: 0 16px;
  }

  a {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    padding: 0 16px;
    flex-shrink: 0;
    font-size: ${FONT_SIZE.S}px;
    font-weight: ${FONT_WEIGHT.NORMAL};
    border-radius: 20px;
    border: 1px solid rgb(${COLOR.GRAY1000.rgb}, 0.2);
    user-select: none;

    &:nth-of-type(n + 2) {
      margin-left: 8px;
    }

    ${mq.sp} {
      height: 32px;
      margin: 0;
      font-size: ${FONT_SIZE.XS}px;
    }
  }
`;

export const SpanSpItem = styled.span`
  display: inline-flex;
  flex-shrink: 0;
`;

export const ButtonArrow = styled.button<{
  isVideoSubPage: boolean;
  isRight?: boolean;
}>`
  position: absolute;
  top: 0;
  ${({ isRight }) => (isRight ? `right: 0;` : `left: 0;`)}
  width: 32px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    to ${({ isRight }) => (isRight ? "right" : "left")},
    transparent 20%,
    ${COLOR.GRAY100.code}
  );

  ${({ isRight }) => {
    return `
      border-top-${isRight ? "left" : "right"}-radius: 4px;
      border-bottom-${isRight ? "left" : "right"}-radius: 4px;`;
  }}
`;

export const DivSpWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DivSpColumn = styled.div`
  display: flex;

  &:nth-of-type(n + 2) {
    margin-top: 8px;
  }
`;

export const Skeleton = styled(_Skeleton)`
  flex-shrink: 0;
`;
